import { useEffect, useState } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { Card } from "@/components/ui/card";
import { Bell, Check } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function Notifications() {
  const [items, setItems] = useState([]);

  const load = () => api.get("/my/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => {
    await api.post(`/my/notifications/${id}/read`);
    load();
  };

  return (
    <div data-testid="notifications-page">
      <PageHeader title="Notifications" subtitle="Approvals, applications, exits, and announcements across your workspace." />

      <Card className="hr-card divide-y divide-gray-100" data-testid="notifications-list">
        {items.length === 0 && <div className="p-10 text-center text-sm text-gray-500">No notifications.</div>}
        {items.map((n) => (
          <div key={n.id} className={`p-4 flex items-start gap-3 ${!n.read ? "bg-[#1E88E5]/5" : ""}`} data-testid={`notif-${n.id}`}>
            <div className="h-9 w-9 rounded-lg bg-[#F26B3A]/5 text-[#0F172A] grid place-items-center">
              <Bell className="h-4 w-4" />
            </div>
            <div className="flex-1">
              <div className="text-sm font-medium text-gray-800">{n.title}</div>
              <div className="text-xs text-gray-500 mt-0.5">{n.body}</div>
              <div className="text-[10px] uppercase tracking-wider text-gray-400 mt-1">{new Date(n.created_at).toLocaleString()} · {n.kind?.replace(/_/g, " ")}</div>
            </div>
            {!n.read && (
              <Button size="sm" variant="ghost" onClick={() => markRead(n.id)} data-testid={`read-${n.id}`}>
                <Check className="h-3.5 w-3.5" />
              </Button>
            )}
          </div>
        ))}
      </Card>
    </div>
  );
}
